import React, { useEffect, useRef, useState } from 'react';
import { string } from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';
import { REQUEST_PREMIERE_URL } from '../config/primaryLinks';
import {
  HeaderContainer,
  HeaderIconButton,
  HeaderLeft,
  HeaderMenuItem,
  HeaderMenuPanel,
  HeaderMenu,
  HeaderProfileButton,
  HeaderRight,
} from './Header.styles';

function Header({ logoPath, profilePath }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const { signOutUser } = useAuth();

  useEffect(() => {
    const onDocClick = (event) => {
      if (!menuRef.current) return;
      if (!menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    const onEscape = (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onEscape);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
      document.removeEventListener('keydown', onEscape);
    };
  }, []);

  const handleSignOut = async () => {
    sessionStorage.removeItem('selectedProfile');
    sessionStorage.removeItem('pendingProfile');
    sessionStorage.removeItem('pendingInviteMeta');
    await signOutUser();
    navigate('/login');
  };

  return (
    <HeaderContainer>
      <HeaderLeft>
        {logoPath ? (
          <img
            src={logoPath}
            alt="Sushflix"
          />
        ) : (
          <span>SUSHFLIX</span>
        )}
        <HeaderMenu>Home</HeaderMenu>
        <HeaderMenu>TV Shows</HeaderMenu>
        <HeaderMenu>Movies</HeaderMenu>
        <HeaderMenu>New & Popular</HeaderMenu>
        <HeaderMenu>My List</HeaderMenu>
      </HeaderLeft>
      <HeaderRight>
        <HeaderIconButton type="button" aria-label="Search">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="7" />
            <line x1="20" y1="20" x2="16.5" y2="16.5" />
          </svg>
        </HeaderIconButton>
        <HeaderIconButton type="button" aria-label="Notifications">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 8a6 6 0 10-12 0c0 7-3 7-3 7h18s-3 0-3-7" />
            <path d="M13.73 21a2 2 0 01-3.46 0" />
          </svg>
        </HeaderIconButton>
        <div ref={menuRef} style={{ position: 'relative' }}>
          <HeaderProfileButton
            type="button"
            style={profilePath ? { backgroundImage: `url(${profilePath})` } : undefined}
            aria-label="Profile menu"
            aria-expanded={open}
            onClick={() => setOpen((prev) => !prev)}
          />
          {open ? (
            <HeaderMenuPanel>
              <HeaderMenuItem
                type="button"
                onClick={() => {
                  setOpen(false);
                  navigate('/profiles');
                }}
              >
                Switch Profile
              </HeaderMenuItem>
              <HeaderMenuItem
                type="button"
                onClick={() => {
                  setOpen(false);
                  navigate('/');
                }}
              >
                Back to Veeflix
              </HeaderMenuItem>
              <HeaderMenuItem
                type="button"
                onClick={() => {
                  setOpen(false);
                  window.open(REQUEST_PREMIERE_URL, '_blank', 'noreferrer');
                }}
              >
                Request a New Flix
              </HeaderMenuItem>
              <HeaderMenuItem
                type="button"
                onClick={() => {
                  setOpen(false);
                  handleSignOut();
                }}
              >
                Sign out
              </HeaderMenuItem>
            </HeaderMenuPanel>
          ) : null}
        </div>
      </HeaderRight>
    </HeaderContainer>
  );
}

export default Header;

Header.propTypes = {
  logoPath: string,
  profilePath: string,
};
